import { Component, effect, HostBinding, input, output, signal } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BaseFile } from 'src/app/bar/services/blobs/blobs-storage.service';
import { getExtensionByFileName, splitFileName } from '@local/ts-infra';
import { BlobContextMenuService } from 'src/app/bar/services/blobs/blob-context-menu.service';
import { isExtension } from '@local/common-web';
import { stopEvent } from '@shared/utils/elements-util';

@UntilDestroy()
@Component({
  selector: 'chat-file',
  templateUrl: './chat-file.component.html',
  styleUrl: './chat-file.component.scss',
})
export class ChatFileComponent {
  readonly MAX_CHARS_FILE_NAME = 17;

  private isExtension = isExtension();

  fileName = signal<string>('');

  file = input<BaseFile>();
  viewMode = input<'view' | 'edit'>();

  removeFile = output<string>();

  @HostBinding('attr.isExtensionMode')
  get isExtensionMode() {
    return this.isExtension;
  }

  constructor(private blobContextMenuService: BlobContextMenuService) {
    effect(
      () => {
        if (this.file()) {
          this.fileName.set(splitFileName(this.file()?.name, getExtensionByFileName(this.file().name)));
        }
      },
      { allowSignalWrites: true }
    );
  }

  openContextMenu(event: MouseEvent) {
    if (this.viewMode() === 'edit') {
      return;
    }
    stopEvent(event);
    this.blobContextMenuService.openContextMenu(event, this.file(), this.isExtension ? ['download'] : ['preview', 'download']);
  }
}
